import { Component, ChangeDetectionStrategy, Input, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseResizableComponent } from '@src/app/modules/base';
import { TuiDialogService } from '@taiga-ui/core';
import { tuiFormatNumber } from '@taiga-ui/core';

import { LoyaltyProgramProductDiscountType } from '../../models';

@Component({
  selector: 'lp-discount-tag',
  templateUrl: './discount-tag.component.html',
  styleUrls: ['./discount-tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscountTagComponent extends BaseResizableComponent {
  private readonly translateService = inject(TranslateService);
  private readonly dialogService = inject(TuiDialogService);

  @Input() productDiscountType?: LoyaltyProgramProductDiscountType;
  @Input() productDiscount?: string | number;
  /**
   * Вид отображения:
   * - prefix - будет добавлен префикс "Скидка"
   * - default - без префикса
   */
  @Input() variant: 'default' | 'prefix' = 'default';

  private readonly MAX_TAG_LENGTH = 23;
  private readonly DISCOUNT_TITLE = this.translateService.instant('components.loyaltyViewInfoBlock.labels.discount');

  get discountType(): LoyaltyProgramProductDiscountType {
    return this.productDiscountType ?? 'rate';
  }

  get originDiscount(): string | number {
    return this.productDiscount ?? 0;
  }

  get discount(): string {
    const discountType = this.discountType;
    const discount = this.originDiscount;

    if (discountType === 'tag') {
      const tag = discount.toString();

      if (tag.length > this.MAX_TAG_LENGTH) {
        return tag.slice(0, this.MAX_TAG_LENGTH - 3) + '...';
      }

      return tag;
    }

    const prefixForNonTagType = this.variant === 'prefix' ? this.DISCOUNT_TITLE + ' ' : '-';

    if (discountType === 'cash') {
      return `${prefixForNonTagType}${tuiFormatNumber(Number(discount))} ₽`;
    }

    // `rate` as default
    return `${prefixForNonTagType}${discount}%`;
  }

  get isPossibleToShowDialog(): boolean {
    return this.discountType === 'tag' && this.originDiscount.toString().length > this.MAX_TAG_LENGTH;
  }

  onShowDiscount(event: MouseEvent) {
    if (this.isPossibleToShowDialog) {
      event.stopPropagation();
      event.preventDefault();

      this.dialogService
        .open(this.originDiscount.toString(), {
          label: this.translateService.instant('components.loyaltyTermsStep.fields.discount'),
          size: 's',
        })
        .subscribe();
    }
  }
}
